import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { parseDataSQL } from '../utils/dataJogo';

export default function MeusPremios() {
  const [premios, setPremios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/premiacoes/meus').then(setPremios).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  return (
    <div>
      <h1 className="page-title">Meus Prêmios</h1>
      {premios.length === 0 && <p className="empty-msg" style={{ color: 'var(--text2)', textAlign: 'center', padding: '40px 0' }}>Você ainda não resgatou prêmios.</p>}
      {premios.map(p => (
        <div key={p.id} className="card" style={{ marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{ fontSize: 28 }}>🎁</span>
            <div style={{ flex: 1 }}>
              <strong style={{ display: 'block', fontSize: 15 }}>{p.premiacao_nome}</strong>
              <span style={{ fontSize: 12, color: 'var(--text2)' }}>{p.premiacao_descricao}</span>
              <span style={{ display: 'block', fontSize: 12, color: 'var(--primary)', marginTop: 4 }}>
                Resgatado em: {parseDataSQL(p.data_resgate).toLocaleDateString('pt-BR')}
              </span>
            </div>
            <span style={{ background: 'rgba(108,99,255,0.2)', color: 'var(--primary)', padding: '4px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>
              {p.pontuacao_necessaria} pts
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
